<div class="container">
  <div class="row actions">
    <div class="col-12">
      <a (click)="goBack()" class="btn-link btn-back">
        <cx-icon [type]="iconType.CARET_LEFT"></cx-icon>
        {{ 'faqItems.actions.backToOverview' | cxTranslate }}
      </a>
    </div>
  </div>
  @if (faqItem$ | async; as faqItem) {
    <div class="row mt-4 mt-md-5">
      <div class="col-12">
        <h3 class="faq-item-title" [innerHTML]="faqItem?.title | textHighlight: (searchTerm$ | async)"></h3>
      </div>
      <div class="col-12">
        @for (faqContentItem of faqItem?.faqContentItems; track faqContentItem) {
          <div class="row mt-3 mb-3">
            @if (faqContentItem?.text) {
              <div class="col-12">
                <span [innerHTML]="faqContentItem.text | cxSupplementHashAnchors | textHighlight: (searchTerm$ | async)">
                </span>
              </div>
            }
            @if (faqContentItem?.imageUrl) {
              <div class="col-12 mt-3">
                <img class="u-img-fluid" [attr.src]="faqContentItem.imageUrl" [attr.alt]="''" />
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
